// @flow

import * as React from 'react';
import Icon from 'sail/Icon';
import * as SailIconAssets from 'sail/Icon/Assets';
import type {IconColor, IconSize} from 'sail/Icon/types';
import {ProductIcon} from 'sail/ProductIcon';
import type {ProductIconSizes} from 'sail/ProductIcon/types';
import * as ProductIcons from 'sail/ProductIcon/Assets';
import {DocsIconAssets} from './DocsIconAssets';

export * from './DocsIconAssets';

export type DocsIconCategory = 'general' | 'nav' | 'product';

type DocsIconProps = {|
  category?: DocsIconCategory,
  className?: string,
  color?: IconColor,
  disabled?: boolean,
  icon: string,
  size?: IconSize,
  'aria-hidden'?: boolean,
|};

export const DocsIcon = ({
  category = 'general',
  icon,
  ...iconProps
}: DocsIconProps) => {
  if (category === 'product') {
    const size: ProductIconSizes = (iconProps.size: any);

    if (ProductIcons[icon]) {
      return (
        <ProductIcon {...iconProps} size={size} icon={ProductIcons[icon]} />
      );
    }
  }

  let asset = DocsIconAssets[category][icon];

  if (!asset) {
    asset = SailIconAssets[icon];
  }

  // If the icon can't be found, write a console warning and use a default icon instead.
  if (!asset) {
    // eslint-disable-next-line no-console
    console.warn(
      `Couldn't find a DocsIcon with the name ${icon} in the category ${category}`,
    );
    asset = 'help';
  }

  return <Icon icon={asset} {...iconProps} />;
};
